import type { ThemeState } from '@atlaskit/tokens';

export const mobileAppTheme: Partial<ThemeState> = {
	colorMode: 'auto',
};
